import { callDecimal } from "../utils.ts";
import { ManageAssetWithLicense } from "../common-types/manageAssets.ts";

type Comparitor = "gt" | "gte" | "lt" | "lte";
interface LicenseParams {
  filter: {
    expired: boolean;
    expiredAt?: { isoDate: string; cmp?: Comparitor };
  };
  // Defaults to most recently created first (-createdAt)
  // Additional attributes may be supported
  sort?: "expiresAt" | "-expiresAt" | "createdAt" | "-createdAt";
}
/**
 * By default includes items in your license that may have expired
 * @see getActiveAssets
 * @see getExpiredAssets
 */
function getLicense(
  oneIndexedPage: number,
  pageSize = 100,
  params: LicenseParams
) {
  const offset = (oneIndexedPage - 1) * pageSize;

  const queryParams = new URLSearchParams();
  queryParams.set("serializer", "asset");
  queryParams.set("page[size]", pageSize.toString());
  queryParams.set("page[offset]", offset.toString());
  queryParams.set("filter[expired]", params.filter.expired.toString());
  if (params.filter.expiredAt) {
    let f = "filter[expiresAt]";
    if (params.filter.expiredAt.cmp) {
      f += `[${params.filter.expiredAt.cmp}]`;
    }
    queryParams.set(f, params.filter.expiredAt.isoDate);
  }
  if (params.sort) {
    queryParams.set("sort", params.sort);
  }
  queryParams.set("without_sso_only", "true");

  return callDecimal<ManageAssetWithLicense[]>(
    `/api/v1/licenses?${queryParams.toString()}`
  );
}

export async function getActiveAssets(
  oneIndexedPage: number,
  pageSize?: number
) {
  return getLicense(oneIndexedPage, pageSize, {
    filter: { expired: false },
  });
}

export async function getExpiredAssets(
  oneIndexedPage: number,
  opts?: {
    pageSize?: number;
    expiredAt?: LicenseParams["filter"]["expiredAt"];
  }
) {
  return getLicense(oneIndexedPage, opts?.pageSize, {
    filter: { expired: true, expiredAt: opts?.expiredAt },
    sort: "-expiresAt",
  });
}

export function returnAsset(vbid: string) {
  return callDecimal<unknown>(`/api/v1/licenses/${vbid}/return`, {
    method: "PUT",
    body: JSON.stringify({
      data: {
        // Set to empty string because it's not used for cache busting, but in the final
        // implementation I think it would be preferable for decimal to look this up,
        // assuming it's needed at all
        brand: "",
      },
    }),
  });
}
